var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVan = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 64 64"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1D1D1B",
  fillRule: "evenodd",
  d: "M4.59 11.25A2 2 0 0 1 6 10.67h38.67a2 2 0 0 1 1.77 1.07l7.05 13.46 8.12 4.37a2 2 0 0 1 1.06 1.76v15.34a2 2 0 0 1-2 2H56.5A8.34 8.34 0 0 1 40.06 48h-15.4v-4h15.9a8.34 8.34 0 0 1 15.78.67h2.33V32.53l-6-3.23v.03H29.33V14.67H6.83L4 17.49v31.18H0v-32a2 2 0 0 1 .59-1.42zm38.87 3.42 5.58 10.66h-15.7V14.67zM15 42.67a4.33 4.33 0 1 0 0 8.66 4.33 4.33 0 0 0 0-8.66M6.67 47a8.33 8.33 0 1 1 16.66 0 8.33 8.33 0 0 1-16.66 0M44 47a4.33 4.33 0 1 1 8.67 0A4.33 4.33 0 0 1 44 47",
  clipRule: "evenodd"
})));
export { SvgVan as ReactComponent };
export default new URL("/home/runner/_work/motorway-seller-webapp/motorway-seller-webapp/src/client/assets_seller/ulez/van.svg", import.meta.url).toString();